const base64UrlEncode = (input) => {
  const json = typeof input === 'string' ? input : JSON.stringify(input);
  const bytes = new TextEncoder().encode(json);
  let binary = '';
  for (let i = 0; i < bytes.length; i += 1) {
    binary += String.fromCharCode(bytes[i]);
  }
  const base64 = btoa(binary);
  return base64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/g, '');
};

const base64UrlDecodeToString = (base64Url) => {
  const padded = base64Url.replace(/-/g, '+').replace(/_/g, '/')
    + '==='.slice((base64Url.length + 3) % 4);
  const binary = atob(padded);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i += 1) {
    bytes[i] = binary.charCodeAt(i);
  }
  return new TextDecoder().decode(bytes);
};

export const buildResultsSharePayload = (profile) => {
  const payload = {
    v: 1,
    p: profile?.primaryType || null,
    s: profile?.secondaryType || null,
    pct: profile?.percentages || null,
    conf: profile?.confidence || null,
    sv: profile?.scoringVersion || null,
  };
  return payload;
};

export const encodeResultsShareParam = (profile) => {
  return base64UrlEncode(buildResultsSharePayload(profile));
};

export const decodeResultsShareParam = (shareParam) => {
  if (!shareParam || typeof shareParam !== 'string') return null;
  try {
    const json = base64UrlDecodeToString(shareParam);
    const parsed = JSON.parse(json);
    if (!parsed || parsed.v !== 1) return null;
    return parsed;
  } catch (e) {
    return null;
  }
};

